(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedDosageUnitDialogController', MedDosageUnitDialogController);

    MedDosageUnitDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MedDosageUnit', 'Medication', 'Corporation'];

    function MedDosageUnitDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MedDosageUnit, Medication, Corporation) {
        var vm = this;

        vm.medDosageUnit = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medDosageUnit.id !== null) {
                MedDosageUnit.update(vm.medDosageUnit, onSaveSuccess, onSaveError);
            } else {
                MedDosageUnit.save(vm.medDosageUnit, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:medDosageUnitUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
